(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["victor-product-premium"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var thumb = event.target.closest('[data-vc-product-thumb]');
  if (thumb) {
    var mainImage = document.getElementById('VCProductMainImage');
    if (mainImage && thumb.dataset.image) {
      mainImage.src = thumb.dataset.image;
      mainImage.removeAttribute('srcset');
      document.querySelectorAll('[data-vc-product-thumb]').forEach(function(item){ item.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    }
  }

  var minus = event.target.closest('[data-vc-qty-minus]');
  var plus = event.target.closest('[data-vc-qty-plus]');
  if (minus || plus) {
    var qty = (minus || plus).parentElement.querySelector('input[name="quantity"]');
    if (!qty) return;
    var value = parseInt(qty.value || '1', 10);
    if (minus) qty.value = Math.max(1, value - 1);
    if (plus) qty.value = value + 1;
  }
});

  } catch(e) { console.error(e); }
})();
})();
